import { Pipe, PipeTransform } from '@angular/core';
import { KrampSpecial } from './kramp-special';

@Pipe({
  name: 'searchKrampSpecials',
})
export class SearchKrampSpecialsPipe implements PipeTransform {
  transform(items: KrampSpecial[], searchText: string): KrampSpecial[] {
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();

    return items.filter(it => {
      const ksn = (it.krampSupplierName ?? '').toLowerCase();
      return (
        it.sku.toLowerCase().includes(searchText) ||
        it.description.toLowerCase().includes(searchText) ||
        it.krampSpecialCode.toLowerCase().includes(searchText) ||
        it.krampSupplierSku.toLowerCase().includes(searchText) ||
        it.creationBy.toLowerCase().includes(searchText) ||
        ksn.includes(searchText)
      );
    });
  }
}
